import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import BottomNavigation from '@mui/material/BottomNavigation'
import { isExternalUrl } from '../../../utils'
import { ExitModal } from '../ExitModal/index'
import { useGlobalStore } from '../../../services/store/store'
import { StyledBottomNavigationAction } from './components'
import {
	OpsotHomeIcon,
	OpsotSearchIcon,
	OpsotToolkitIcon,
	OpsotExitIcon
} from '../assets'

const BottomNav = () => {
	const theme = useTheme()
	const navigate = useNavigate()
	const [value, setValue] = useState(window.location.pathname)
	const [isExitOpen, setIsExitOpen] = useState(false)
	const location = useLocation()
	const userToken = useGlobalStore((state) => state.userToken)
	const navItemStyle = {
		display: userToken ? 'flex' : 'none'
	}

	useEffect(() => {
		setValue(location.pathname)
	}, [location])

	const handleChange = (link) => {
		if (isExternalUrl(link)) {
			if (!isExitOpen) {
				setIsExitOpen(true)
				return
			}
			window.location.href = link
			return
		}
		setValue(link)
		navigate(link)
	}

	return (
		<Paper
			sx={{
				position: 'fixed',
				bottom: 0,
				left: 0,
				right: 0,
				zIndex: 1000,
				height: { xs: '68px', sm: '128px' },
				width: '100%',
				[theme.breakpoints.up('md')]: {
					display: 'none'
				}
			}}
			id="bottom-nav"
			elevation={0}
		>
			<BottomNavigation
				showLabels
				value={value}
				sx={{
					height: { xs: '68px', sm: '128px' },
					justifyContent: userToken ? 'space-between' : 'flex-end'
				}}
			>
				<StyledBottomNavigationAction
					sx={navItemStyle}
					label="Home"
					value="/"
					onClick={() => handleChange('/')}
					icon={<OpsotHomeIcon />}
					key="home"
				/>
				<StyledBottomNavigationAction
					sx={navItemStyle}
					label="Search"
					value="/search"
					onClick={() => handleChange('/search')}
					icon={<OpsotSearchIcon />}
					key="search"
				/>
				<StyledBottomNavigationAction
					sx={navItemStyle}
					label="Toolkits"
					value="/toolkits"
					onClick={() => handleChange('/toolkits')}
					icon={<OpsotToolkitIcon />}
					key="toolkits"
				/>
				<StyledBottomNavigationAction
					label="Back to College of Policing"
					value="https://www.college.police.uk/"
					onClick={() => handleChange('https://www.college.police.uk/')}
					icon={<OpsotExitIcon />}
					sx={{ backgroundColor: 'primary.main', color: 'white' }}
					key="exit"
					backButton
				/>
			</BottomNavigation>

			<ExitModal
				isExitOpen={isExitOpen}
				setIsExitOpen={setIsExitOpen}
				handleChange={handleChange}
			/>
		</Paper>
	)
}

export default BottomNav
